module.exports = __webpack_public_path__ + "static/media/infographic_mobile.984407c8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/infographic_mobile.svg
 ** module id = 457
 ** module chunks = 0
 **/